import { useDispatch, useSelector } from "../../../redux/hooks";
import { useEffect, useMemo, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { ICell } from "../../../generator/Cell/Cell.types";
import { ICol } from "../../../interfaces";
import { colsToUUIDObject } from "../../../redux/utils/convertToUUIDKeys";
import { Text } from "@mantine/core";
import {
  addGuernseyData,
  setGuernseyData,
} from "../../../redux/slices/generatorFeaturesSlice";
import { useController, useFormContext } from "react-hook-form";
import { StyledGuernseyTr } from "./Guernsey.styled";
import { GuernseyProps, IGuernseyRow, TGuernseyRows } from "./Guernsey.types";
import { parseIntoInputRows } from "./Guernsey.utils";

interface Props extends GuernseyProps {
  onChange?: (value: string) => void;
  summary?: boolean;
  lbeid?: string;
}

const GuernseyMulti = ({
  content,
  value,
  rowIndex,
  onChange,
  summary,
  lbeid,
}: Props) => {
  const { guernseyType } = useSelector(state => state.generatorFeaturesSlice);
  const dispatch = useDispatch();

  useEffect(() => {
    const type =
      guernseyType && rowIndex === guernseyType.rowIndex
        ? guernseyType.key
        : value;
    if (!type || !content) return;
    if (guernseyType && rowIndex === guernseyType.rowIndex) {
      onChange?.(guernseyType.key);
    }

    if (
      ((guernseyType && guernseyType?.rowIndex === rowIndex) || type) &&
      rowIndex !== undefined
    ) {
      dispatch(
        addGuernseyData({
          rowIndex,
          rows: parseIntoInputRows(content, type, summary, lbeid),
        }),
      );
    }
  }, [guernseyType, value, content, rowIndex, onChange, dispatch, summary]);

  return (
    <div>
      <table>
        {value &&
          content?.[value] &&
          content[value].map((r: IGuernseyRow) => (
            <StyledGuernseyTr>
              <td className="bottom-border">
                {summary ? <p>{r.name}</p> : <Text>{r.name}</Text>}
              </td>
            </StyledGuernseyTr>
          ))}
      </table>
    </div>
  );
};
export default GuernseyMulti;
